<template>
<el-card class="current-info-card">
  <div slot="header" class="clearfix">
    <span>最新の状況</span>
  </div>
  <el-table :data="this.cameraData" :show-header=false align="center">
      <el-table-column prop="key" label="" min-width="120"/>
      <el-table-column prop="val" label="" min-width="180" align="center" />
  </el-table>
</el-card>
</template>

<script>

export default {
  props: {
      cameraData: {
        default: () => {},
      }
  },

}

</script>
    
<style scoped>
.key{
    background: lightsteelblue;
}
.val{
    background: aliceblue;
}

</style>